import { jsx as a, jsxs as I } from "react/jsx-runtime";
import { Hint as T, ListBoxSelect as b, Tooltip as h } from "@systemeio/ui";
import { useEditorState as _ } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useMemo as u } from "react";
import { ToolbarSelectButton as v } from "../../components/content-controls/toolbar-select-button.mjs";
import { TOOLTIP_STYLES as g } from "../../constants/default-styles.mjs";
import { useTranslation as D } from "../../i18n.mjs";
import { getFontFamilyCode as N, getFontFamilyOptionsData as O } from "./utils.mjs";
import { CloseIcon as S } from "@systemeio/ui/icons";
import { isImageSelected as L } from "../image-extension/utils/is-image-selected.mjs";
const q = (e, C) => {
  const { t: i } = D(), { fontFamilyOptionsData: F, noFontFamilyElement: p, disabled: x } = C ?? {}, t = _({
    editor: e,
    selector: ({ editor: n }) => ({
      isEditable: (n == null ? void 0 : n.options.editable) ?? !1,
      fontFamily: n == null ? void 0 : n.getAttributes("textStyle").fontFamily,
      isImageSelected: L(n)
    })
  }), s = !(t != null && t.isEditable) || !!(t != null && t.isImageSelected) || x, m = t != null && t.fontFamily ? N(t.fontFamily) : void 0, c = u(
    () => F ?? O(),
    [F]
  ), y = u(
    () => p ?? /* @__PURE__ */ a(T, { label: i("font_family.default_hint"), children: i("font_family.default") }),
    [p, i]
  );
  return u(() => {
    const n = (o) => {
      var f;
      if (!e || !o) return null;
      const l = (f = c.find((r) => r.id === o)) == null ? void 0 : f.fontFamilyValue;
      if (!l) return null;
      e.chain().focus().setFontFamily(l).run();
    }, E = () => {
      e && e.chain().focus().unsetFontFamily().run();
    }, d = (o) => {
      const l = c.find((r) => r.id === m), f = (l == null ? void 0 : l.customCaption) ?? (l == null ? void 0 : l.caption);
      return /* @__PURE__ */ a("div", { className: "flex items-center", children: /* @__PURE__ */ I(v, { className: "flex gap-1", disabled: s, open: o, children: [
        m ? f : y,
        !!m && /* @__PURE__ */ a(
          S,
          {
            onClick: (r) => {
              r.stopPropagation(), E();
            },
            className: "fill-text-primary cursor-pointer"
          }
        )
      ] }) });
    };
    return {
      toolbarRender: /* @__PURE__ */ a(
        b,
        {
          disabled: s,
          data: c,
          value: m,
          onChange: n,
          children: (o) => /* @__PURE__ */ a(
            h,
            {
              disabled: s,
              label: i("font_family.title"),
              anchor: "left",
              ...g,
              children: d(o)
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ a(
        b,
        {
          optionsClassName: "z-40",
          disabled: s,
          data: c,
          value: m,
          onChange: n,
          children: (o) => /* @__PURE__ */ a(
            h,
            {
              disabled: s,
              label: i("font_family.title"),
              anchor: "left",
              ...g,
              children: d(o)
            }
          )
        }
      )
    };
  }, [e, s, m, c, y, i]);
};
export {
  q as useFontFamilyExtensionToolbar
};
